//Include angular-ui dependency in resources on the side and as 'ui'
angular.module('iconoglobe').directive('loadSliderOnReach', ["$window","$document", '$parse', "$http", "$compile","$rootScope", function(w, d, p, $http, UserLocation, $rootScope) {
    return {
        require: '?ngModel',
        link: function(scope, element, attrs, model) {
          
          d.bind('scroll', function(){
            handler();
          });
          var worldEventData = [{
                  genre: 'views.Adventures',
                  img: 'app/images/categories/img.jpg'
              },
              {
                  genre: 'views.Festivals',
                  img: 'app/images/categories/Festival-exhibitions.jpg'
              },
              {
                  genre: 'views.Gaming',
                  img: 'app/images/categories/Gaming-amusement.jpg'
              },
              {
                  genre: 'views.Museums',
                  img: 'app/images/categories/Museums-Cinema.jpg'
              },
              {
                  genre: 'views.Music',
                  img: 'app/images/categories/Music-performances.jpg'
              },
              {
                  genre: 'views.Nature',
                  img: 'app/images/categories/Nature-sites.jpg'
              },
              {
                  genre: 'views.Sports',
                  img: 'app/images/categories/Sports-competitions.jpg'
              },
              {
                  genre: 'views.Childrens',
                  img: 'app/images/categories/Childrens.jpg'
              }
          ];
          
          var handler = function() {
            var cursor = w.pageYOffset + w.innerHeight + 100;
            if(cursor > element.offset().top && (!model.$viewValue || model.$viewValue.length === 0 ) ){
                
                switch(attrs.ngModel){
                  case "slickFestivals":
                    if(scope.festivals) return;
                    scope.festivals = true;
                    $rootScope.loadPromoSlider.festivals = true;
                    model.$setViewValue(scope.slickSlider2);
                    break;
                  case "slickGaming":
                    if(scope.gaming) return;
                    scope.gaming = true;
                    $rootScope.loadPromoSlider.gaming = true;
                    model.$setViewValue(scope.slickSlider3);
                    break;
                  case "slickMuseums":
                    if(scope.museums) return;
                    scope.museums = true;
                    $rootScope.loadPromoSlider.museums = true;
                    model.$setViewValue(scope.slickSlider4);
                    break;
                  case "slickMusic":
                    if(scope.music) return;
                    scope.music = true;
                    $rootScope.loadPromoSlider.music = true;
                    model.$setViewValue(scope.slickSlider5);
                    break;
                  case "slickNature":
                    if(scope.nature) return;
                    scope.nature = true;
                    $rootScope.loadPromoSlider.nature = true;
                    model.$setViewValue(scope.slickSlider6);
                    break;
                  case "slickSports":
                    if(scope.sports) return;
                    scope.sports = true;
                    $rootScope.loadPromoSlider.sports = true;
                    model.$setViewValue(scope.slickSlider7);
                    break;
                  case "slickChildrens":
                    if(scope.children) return;
                    scope.children = true;
                    $rootScope.loadPromoSlider.children = true;
                    model.$setViewValue(scope.slickSlider8);
                    break;
                  case "worldEvents":
                    model.$setViewValue(worldEventData);
                    break;
                  default:
                    // do nothing
                }
            }
          };
          element.on('$destroy', function(){
            d.unbind('scroll');
          });
        }
    };
}]);